import React, { useEffect } from "react";
import Common_title from "../common-components/common-title/Common_title";

import { useDispatch, useSelector } from "react-redux";
import { getPrivacy_Policy } from "../../features/privacypolicy/Slice";

const Privacy_Policy = () => {
  const dispatch = useDispatch();
  const privacypoli = useSelector(
    (state) => state.privacypolicy.privacypolicies
  );

  useEffect(() => {
    dispatch(getPrivacy_Policy());
  }, [dispatch]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <section className="Terms_Conditions">
      <div className="container-fluid">
        <Common_title title="Privacy" titleblack="Policy" />
        <div className="content_div">
          {privacypoli && privacypoli.content ? (
            <div
              className="description_text"
              dangerouslySetInnerHTML={{ __html: privacypoli.content }}
            />
          ) : (
            <p className="no-data">No Privacy Policy Available</p>
          )}
        </div>
        
      </div>
    </section>
  );
};

export default Privacy_Policy;